import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import BoardBaseOffer from "./BoardBaseOffer";


class BoardBases extends Component {

	render() {
		const { boardBases } = this.props;

		return (
			<div>
				<div className="rooms">
					<div className="room-offers">
						{Object.values(boardBases).map((boardBase, index) => {
							return <BoardBaseOffer
								key={index}
								boardBase={boardBase}
								isLast={Object.keys(boardBases).length - 1 === index}
							/>
						})}
					</div>
				</div>
			</div>
		);
	}
}


export default compose(
	connect(state => ({
		formValues: getFormValues('bookingForm')(state),
		boardBases: state.app.boardBases,
	})),
)(BoardBases)


// WEBPACK FOOTER //
// ./src/components/BoardBases/index.jsx